



<div class="row home-page no-gutters">
  <ng-template  [ngIf]="isLoad" [ngIfElse]="Loading">
    <div class="col-12 margin-block">
        <app-offline-service-menu  
          [servicesList]="pageConfig.servicesList">
        </app-offline-service-menu>
      </div>
    <div class="col-12">
      <router-outlet></router-outlet>
    </div>
    <div class="col-12">
      <div></div>
    </div>
  </ng-template>
  <ng-template #Loading></ng-template>
</div>
